import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createBlock as _createBlock, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "d-flex justify-content-between" }
const _hoisted_2 = { class: "d-flex align-items-center" }
const _hoisted_3 = { class: "fs-2 mr-3" }
const _hoisted_4 = { class: "d-flex gap-5 align-items-center" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "card mb-4 mb-xxl-6" }
const _hoisted_7 = { class: "card-body p-5" }
const _hoisted_8 = { class: "d-flex flex-wrap gap-4" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "symbol symbol-100px symbol-lg-160px symbol-fixed position-relative" }
const _hoisted_11 = { class: "flex-grow-1 flex-wrap gap-4" }
const _hoisted_12 = { class: "d-flex justify-content-between align-items-start flex-wrap mb-2" }
const _hoisted_13 = { class: "d-flex flex-column" }
const _hoisted_14 = { class: "d-flex align-items-center mb-2" }
const _hoisted_15 = {
  key: 0,
  class: "text-gray-800 text-hover-primary fs-2 fw-bold me-1"
}
const _hoisted_16 = { class: "list-unstyled" }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = {
  key: 0,
  class: "badge border border-success badge-light-success mb-1"
}
const _hoisted_19 = {
  key: 1,
  class: "badge border border-danger badge-light-danger mb-1"
}
const _hoisted_20 = { class: "d-flex flex-wrap flex-stack" }
const _hoisted_21 = { class: "d-flex flex-column flex-grow-1" }
const _hoisted_22 = { class: "d-flex flex-wrap gap-4" }
const _hoisted_23 = { class: "bg-primary text-white rounded min-w-125px py-3 px-4 mb-3" }
const _hoisted_24 = { class: "d-flex align-items-center" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-graph-up-arrow fs-1 me-2 text-white" }, null, -1)
const _hoisted_26 = { class: "fs-2 fw-bold" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "fw-semobold fs-6" }, "Total", -1)
const _hoisted_28 = { class: "bg-info text-white rounded min-w-125px py-3 px-4 mb-3" }
const _hoisted_29 = { class: "d-flex align-items-center" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-buildings fs-1 me-2 text-white" }, null, -1)
const _hoisted_31 = { class: "fs-2 fw-bold" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { class: "fw-semobold fs-6" }, "Instituciones", -1)
const _hoisted_33 = { class: "d-flex align-items-center" }
const _hoisted_34 = { class: "fs-2 fw-bold" }
const _hoisted_35 = { class: "fw-semobold fs-6" }
const _hoisted_36 = { class: "d-flex flex-column gap-4" }
const _hoisted_37 = { class: "d-flex" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("label", {
  for: "",
  class: "fw-bold w-150px"
}, "Institución", -1)
const _hoisted_39 = { class: "d-flex" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("label", {
  for: "",
  class: "fw-bold w-150px"
}, "Disciplina", -1)
const _hoisted_41 = { class: "d-flex justify-content-end" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-folder-plus text-white fs-2 me-2" }, null, -1)
const _hoisted_43 = {
  key: 0,
  class: "spinner-border spinner-border-sm text-white me-2"
}
const _hoisted_44 = {
  key: 1,
  class: "bi bi-download text-white fs-4 me-2"
}
const _hoisted_45 = { class: "row" }
const _hoisted_46 = { class: "col-sm-3" }
const _hoisted_47 = { class: "col-sm-9" }
const _hoisted_48 = { class: "d-flex justify-content-between mb-4" }
const _hoisted_49 = { class: "card-title m-0" }
const _hoisted_50 = { class: "card-toolbar d-flex align-items-center" }
const _hoisted_51 = /*#__PURE__*/_createElementVNode("label", { class: "me-3 fw-bolder" }, "Estado", -1)
const _hoisted_52 = { class: "d-flex gap-2 align-items-center" }
const _hoisted_53 = ["src"]
const _hoisted_54 = { class: "fw-bold" }
const _hoisted_55 = ["onClick"]
const _hoisted_56 = /*#__PURE__*/_createElementVNode("div", { class: "btn btn-sm btn-secondary py-1 px-3" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-three-dots fs-3 px-0" })
], -1)
const _hoisted_57 = /*#__PURE__*/_createElementVNode("i", { class: "far fa-file-pdf" }, null, -1)
const _hoisted_58 = /*#__PURE__*/_createElementVNode("i", { class: "far fa-file-pdf" }, null, -1)
const _hoisted_59 = /*#__PURE__*/_createElementVNode("i", { class: "far fa-file-pdf" }, null, -1)
const _hoisted_60 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-cart-plus fs-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_avatar = _resolveComponent("el-avatar")!
  const _component_el_page_header = _resolveComponent("el-page-header")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_MixedWidget14 = _resolveComponent("MixedWidget14")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_ModalNominal = _resolveComponent("ModalNominal")!
  const _component_ModalListOrdersPays = _resolveComponent("ModalListOrdersPays")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.dialogSport,
      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.dialogSport) = $event)),
      title: _ctx.evento.name,
      onOpened: _ctx.opened,
      onClosed: _ctx.oClosed,
      fullscreen: true,
      class: "bg-light",
      "show-close": false
    }, {
      header: _withCtx(({ close }) => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_el_page_header, {
            icon: _ctx.ArrowLeft,
            onBack: _ctx.onBack
          }, {
            content: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_component_el_avatar, {
                  size: 32,
                  class: "me-3",
                  src: _ctx.evento.logo
                }, null, 8, ["src"]),
                _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.evento.name), 1)
              ])
            ]),
            _: 1
          }, 8, ["icon", "onBack"]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("i", {
              class: "bi bi-x-lg fs-1 cursor-pointer text-black text-hover-danger",
              onClick: close
            }, null, 8, _hoisted_5)
          ])
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              (_ctx.sportDetails?.logo)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      _createVNode(_component_el_image, {
                        style: {"width":"auto","height":"130px"},
                        src: `${_ctx.REPO}/${_ctx.sportDetails?.logo}`,
                        fit: 'cover',
                        class: "rounded"
                      }, null, 8, ["src"])
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      (_ctx.sportDetails?.name)
                        ? (_openBlock(), _createElementBlock("a", _hoisted_15, _toDisplayString(_ctx.sportDetails?.name) + "(" + _toDisplayString(_ctx.sportDetails?.acronym) + ")", 1))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_16, [
                        (_ctx.sportDetails?.mstatus)
                          ? (_openBlock(), _createElementBlock("li", _hoisted_17, [
                              (_ctx.sportDetails?.mstatus == 'O')
                                ? (_openBlock(), _createElementBlock("span", _hoisted_18, "Inscripciones habilitadas"))
                                : (_openBlock(), _createElementBlock("span", _hoisted_19, "Inscripciones finalizadas"))
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("div", _hoisted_23, [
                        _createElementVNode("div", _hoisted_24, [
                          _hoisted_25,
                          _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.total), 1)
                        ]),
                        _hoisted_27
                      ]),
                      _createElementVNode("div", _hoisted_28, [
                        _createElementVNode("div", _hoisted_29, [
                          _hoisted_30,
                          _createElementVNode("div", _hoisted_31, _toDisplayString(_ctx.listInstitutions.length), 1)
                        ]),
                        _hoisted_32
                      ]),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listRGender, (item, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: index,
                          class: "border border-gray-500 border-dashed rounded min-w-125px py-3 px-4 mb-3"
                        }, [
                          _createElementVNode("div", _hoisted_33, [
                            (item.params)
                              ? (_openBlock(), _createElementBlock("i", {
                                  key: 0,
                                  class: _normalizeClass(`${item.params} fs-1 me-2`)
                                }, null, 2))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_34, _toDisplayString(item.quantity), 1)
                          ]),
                          _createElementVNode("div", _hoisted_35, _toDisplayString(item.name), 1)
                        ]))
                      }), 128))
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_36, [
                _createElementVNode("div", _hoisted_37, [
                  _hoisted_38,
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.idInstitution,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.idInstitution) = $event)),
                    "value-key": "idinstitution",
                    filterable: "",
                    remote: "",
                    "reserve-keyword": "",
                    clearable: "",
                    placeholder: "Ingrese un texto a buscar...",
                    "remote-method": _ctx.getAllClubs,
                    class: "w-100",
                    loading: _ctx.loadingClub,
                    "loading-text": "Buscando..."
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allInstitutions, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.idinstitution,
                          label: item.name,
                          value: item
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue", "remote-method", "loading"])
                ]),
                _createElementVNode("div", _hoisted_39, [
                  _hoisted_40,
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.idsport,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.idsport) = $event)),
                    onChange: _ctx.changeSport,
                    filterable: "",
                    placeholder: _ctx.t('seleccione'),
                    class: "w-100"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listSports, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.idsport,
                          label: item.name,
                          value: item.idsport
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue", "onChange", "placeholder"])
                ]),
                _createElementVNode("div", _hoisted_41, [
                  _createVNode(_component_el_button, {
                    type: "primary",
                    class: "me-4 fw-normal",
                    disabled: _ctx.idInstitution?.idinstitution ? false : true,
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.openDialogNominal(_ctx.idInstitution)))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_42,
                      _createTextVNode(" Registrar ")
                    ]),
                    _: 1
                  }, 8, ["disabled"]),
                  _createVNode(_component_el_dropdown, { trigger: "click" }, {
                    dropdown: _withCtx(() => [
                      _createVNode(_component_el_dropdown_menu, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_dropdown_item, {
                            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.callDownloadFile(
                                                'pdf', 
                                                'sumary-participation-sport', 
                                                {
                                                    a: _ctx.evento.idevent, 
                                                    b: _ctx.idsport, 
                                                    c: ''
                                                }
                                            )))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" Resumen de participación ")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_dropdown_item, {
                            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.callDownloadFile(
                                                'xlsx', 
                                                'zebra-zc300', 
                                                {
                                                    a: _ctx.mbtoa(_ctx.evento.idevent),
                                                    b: _ctx.mbtoa(_ctx.idsport),
                                                    c: '',
                                                    d: _ctx.idcheckdoc
                                                }
                                            )))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" Zebra ZC300 ")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_dropdown_item, {
                            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.callDownloadFile(
                                                'xlsx', 
                                                'consolidated-participation', 
                                                {
                                                    a: _ctx.mbtoa(_ctx.evento.idevent),
                                                    b: _ctx.mbtoa(_ctx.idsport),
                                                    c: '',
                                                    d: _ctx.idcheckdoc
                                                }
                                            )))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" Nominal General ")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_dropdown_item, {
                            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.callDownloadFile(
                                                'xlsx',
                                                `nominal/Competition`,
                                                {
                                                    a: _ctx.mbtoa(_ctx.evento.idevent),
                                                    b: _ctx.mbtoa(_ctx.idsport),
                                                    c: 'all',
                                                    d: _ctx.idcheckdoc
                                                }
                                            )))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" Nominal de competencia ")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_dropdown_item, {
                            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.callDownloadFile(
                                                'pdf',
                                                `credentials`,
                                                {
                                                    a: _ctx.mbtoa(_ctx.evento.idevent),
                                                    b: _ctx.mbtoa(_ctx.idsport),
                                                    c: null,
                                                    d: null,
                                                    e: _ctx.selectionClubs.join(','),
                                                    f: _ctx.idcheckdoc
                                                }
                                            )))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" Credenciales ")
                            ]),
                            _: 1
                          }),
                          (_ctx.sport?.teams > 0)
                            ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
                                key: 0,
                                command: "a",
                                onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.callDownloadFile(
                                                'xlsx', 
                                                `sumary-teams`, 
                                                {
                                                    a: _ctx.mbtoa(_ctx.evento.idevent),
                                                    b: _ctx.mbtoa(_ctx.idsport),
                                                    c: '',
                                                    d: _ctx.idcheckdoc
                                                }
                                            )))
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(" Resumen por equipos ")
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      })
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_el_button, {
                        type: "danger",
                        class: "fw-normal text-white",
                        disabled: _ctx.loadingDownload
                      }, {
                        default: _withCtx(() => [
                          (_ctx.loadingDownload)
                            ? (_openBlock(), _createElementBlock("i", _hoisted_43))
                            : (_openBlock(), _createElementBlock("i", _hoisted_44)),
                          _createTextVNode(" Descargar ")
                        ]),
                        _: 1
                      }, 8, ["disabled"])
                    ]),
                    _: 1
                  })
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_45, [
          _createElementVNode("div", _hoisted_46, [
            _createVNode(_component_MixedWidget14, {
              "widget-classes": "card-xxl-stretch mb-5 mb-xl-8",
              "widget-color": "#d9f5f8",
              loading: false,
              title: "Resumen por tipo de registro",
              items: _ctx.listRTRegister
            }, null, 8, ["items"]),
            _createVNode(_component_MixedWidget14, {
              "widget-classes": "card-xxl-stretch mb-2 mb-xl-4",
              "widget-color": "#fffcf1",
              loading: false,
              title: "Resumen por estado",
              items: _ctx.listRCheckDoc
            }, null, 8, ["items"])
          ]),
          _createElementVNode("div", _hoisted_47, [
            _createElementVNode("div", _hoisted_48, [
              _createElementVNode("div", _hoisted_49, [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.searchClub,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.searchClub) = $event)),
                  placeholder: "Buscar",
                  "prefix-icon": _ctx.Search,
                  clearable: "",
                  class: "me-3 w-300px"
                }, null, 8, ["modelValue", "prefix-icon"])
              ]),
              _createElementVNode("div", _hoisted_50, [
                _hoisted_51,
                _createVNode(_component_el_select, {
                  modelValue: _ctx.idcheckdoc,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.idcheckdoc) = $event)),
                  onChange: _ctx.changeSport,
                  multiple: "",
                  "collapse-tags": "",
                  "collapse-tags-tooltip": "",
                  placeholder: "Estado",
                  class: "w-300px"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listStatus, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.id,
                        label: item.name,
                        value: item.id
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue", "onChange"])
              ])
            ]),
            _withDirectives((_openBlock(), _createBlock(_component_el_table, {
              data: _ctx.filteredClubs,
              border: "",
              "show-summary": "",
              height: _ctx.heightTable,
              style: {"width":"100%"},
              "scrollbar-always-on": true,
              "highlight-current-row": "",
              "header-cell-class-name": "text-black bg-secondary text-uppercase",
              onSelectionChange: _ctx.handleSelectionChange
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  type: "selection",
                  width: "50"
                }),
                _createVNode(_component_el_table_column, {
                  label: _ctx.t('country'),
                  width: "140"
                }, {
                  default: _withCtx(({ row }) => [
                    _createElementVNode("div", _hoisted_52, [
                      (row.country?.flag)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            src: `${_ctx.REPO}/${row.country?.flag}`,
                            class: "w-24px h-15px border rounded"
                          }, null, 8, _hoisted_53))
                        : _createCommentVNode("", true),
                      _createElementVNode("span", _hoisted_54, _toDisplayString(row.country?.name.toUpperCase()), 1)
                    ])
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_el_table_column, {
                  prop: "abrev",
                  label: "Alias",
                  width: "130",
                  sortable: ""
                }),
                _createVNode(_component_el_table_column, {
                  prop: "name",
                  label: "Delegación",
                  sortable: ""
                }, {
                  default: _withCtx(({ row }) => [
                    _createElementVNode("a", {
                      class: "cursor-pointer btn-active-color-primary",
                      onClick: ($event: any) => (_ctx.openDialogNominal(row))
                    }, _toDisplayString(row.name.toUpperCase()), 9, _hoisted_55)
                  ]),
                  _: 1
                }),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dynamicColumns, (col) => {
                  return (_openBlock(), _createBlock(_component_el_table_column, {
                    key: col.prop,
                    prop: col.prop,
                    label: col.label,
                    width: col.width,
                    align: col.align
                  }, null, 8, ["prop", "label", "width", "align"]))
                }), 128)),
                _createVNode(_component_el_table_column, {
                  prop: "quantity",
                  label: "Total",
                  width: "100",
                  align: "center",
                  sortable: ""
                }),
                _createVNode(_component_el_table_column, {
                  label: "OPC",
                  width: "80"
                }, {
                  default: _withCtx(({ row }) => [
                    _createVNode(_component_el_dropdown, null, {
                      dropdown: _withCtx(() => [
                        _createVNode(_component_el_dropdown_menu, null, {
                          default: _withCtx(() => [
                            (_ctx.sportDetails?.categorie == 1)
                              ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
                                  key: 0,
                                  command: "a",
                                  onClick: ($event: any) => (_ctx.callDownloadFile(
                                                'pdf', 
                                                'auxiliar', 
                                                {
                                                    a: _ctx.mbtoa(_ctx.evento.idevent),
                                                    b: _ctx.mbtoa(_ctx.idsport),
                                                    c: _ctx.mbtoa(row.idinstitution)
                                                }
                                            ))
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_57,
                                    _createTextVNode("Ficha Auxiliar ")
                                  ]),
                                  _: 2
                                }, 1032, ["onClick"]))
                              : _createCommentVNode("", true),
                            (_ctx.sportDetails?.categorie == 2)
                              ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
                                  key: 1,
                                  command: "a",
                                  onClick: ($event: any) => (_ctx.callDownloadFile(
                                                'pdf', 
                                                'nominal', 
                                                {
                                                    a: _ctx.mbtoa(_ctx.evento.idevent),
                                                    b: _ctx.mbtoa(_ctx.idsport),
                                                    c: _ctx.mbtoa(row.idinstitution)
                                                }
                                            ))
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_58,
                                    _createTextVNode("Ficha competencia ")
                                  ]),
                                  _: 2
                                }, 1032, ["onClick"]))
                              : _createCommentVNode("", true),
                            _createVNode(_component_el_dropdown_item, {
                              command: "a",
                              onClick: ($event: any) => (_ctx.openDialogNominal(row))
                            }, {
                              default: _withCtx(() => [
                                _hoisted_59,
                                _createTextVNode("Ver detalles ")
                              ]),
                              _: 2
                            }, 1032, ["onClick"]),
                            _createVNode(_component_el_dropdown_item, {
                              command: "a",
                              onClick: ($event: any) => (_ctx.openDialogOrders(row))
                            }, {
                              default: _withCtx(() => [
                                _hoisted_60,
                                _createTextVNode("Ordenes de pago ")
                              ]),
                              _: 2
                            }, 1032, ["onClick"])
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      default: _withCtx(() => [
                        _hoisted_56
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["data", "height", "onSelectionChange"])), [
              [_directive_loading, _ctx.loaderTable]
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "title", "onOpened", "onClosed"]),
    _createVNode(_component_ModalNominal, {
      evento: _ctx.evento,
      sport: _ctx.sportDetails,
      "list-status": _ctx.listStatus,
      "row-club": _ctx.rowClub,
      checkdoc: _ctx.idcheckdoc
    }, null, 8, ["evento", "sport", "list-status", "row-club", "checkdoc"]),
    _createVNode(_component_ModalListOrdersPays, {
      ref: "ModalListOrdersPaysRef",
      "row-club": _ctx.rowClub
    }, null, 8, ["row-club"])
  ], 64))
}